import { SharedWith } from "src/apps/AppFlow/pages";
import { Page } from "src/components/FlowLayout";
import { PageState } from "src/hooks/usePageState";
import { Applicant } from "src/types/Applicant";
import { DebtBalanceAndPaymentsValue, DebtTypeAndLenderNameValue } from "src/types/Application";

import { formatters } from "@fraction/shared";

import { DebtBalanceAndPayments, DebtTypeAndLenderName } from "./pages";

const { DEBT_TYPE_MAP } = formatters.enums;

export interface DebtPagesArgs {
  debtTypeAndLenderName: PageState<DebtTypeAndLenderNameValue>;
  debtBalanceAndPayments: PageState<DebtBalanceAndPaymentsValue>;
  otherApplicants: Applicant[] | undefined;
  applicant: Applicant;
  owners: PageState<Applicant[]>;
  onComplete: () => void;
}

const DebtPages = ({
  debtTypeAndLenderName,
  debtBalanceAndPayments,
  otherApplicants,
  applicant,
  owners,
}: DebtPagesArgs): Page[] =>
  [
    {
      name: "debtTypeAndLenderName",
      component: <DebtTypeAndLenderName {...debtTypeAndLenderName} />,
    },
    {
      name: "debtBalanceAndPayments",
      component: (
        <DebtBalanceAndPayments
          debtType={debtTypeAndLenderName.value?.type}
          lenderName={debtTypeAndLenderName.value?.lenderName || ""}
          {...debtBalanceAndPayments}
        />
      ),
    },
    otherApplicants?.length &&
      applicant && {
        name: "owners",
        component: (
          <SharedWith
            applicant={applicant}
            otherApplicants={otherApplicants || []}
            sharedItemName={`${
              debtTypeAndLenderName.value?.type
                ? DEBT_TYPE_MAP[debtTypeAndLenderName.value?.type].toLowerCase()
                : "debt"
            } with ${debtTypeAndLenderName.value?.lenderName || ""}`}
            {...owners}
          />
        ),
      },
  ].filter((p): p is Page => Boolean(p));

export default DebtPages;
